import {
    CONTENT_ALBUM_POSTS,
    CONTENT_ALBUM_ANALYTICS,
    CONTENT_ALBUMS,
    CONTENT_ALBUMS_COMPARATIVE_TABLE
} from '@/routes/privateRoutes';

// Lib
import { INSTAGRAM, TWITTER } from '@/lib/socialProfile';

// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';
import type { TabsLinkListItemType } from '@/components/composite/TabsLink';

export const TAB_ALBUM_POSTS = 'posts';
export const TAB_ALBUM_ANALYTICS = 'analytics';

export function getTabList(network: SocialProfileNetworkType, albumType: 'stories') {
    switch (network) {
        case TWITTER:
            return [
                {
                    name: 'content:tabs.tweets',
                    icon: 'content',
                    id: TAB_ALBUM_POSTS,
                    url: CONTENT_ALBUM_POSTS
                },
                {
                    name: 'content:tabs.analytics',
                    icon: 'stats',
                    id: TAB_ALBUM_ANALYTICS,
                    url: CONTENT_ALBUM_ANALYTICS
                }
            ];
        case INSTAGRAM:
            return [
                {
                    name: albumType === 'stories' ? 'content:tabs.stories' : 'content:tabs.posts',
                    icon: 'content',
                    id: TAB_ALBUM_POSTS,
                    url: CONTENT_ALBUM_POSTS
                },
                {
                    name: 'content:tabs.analytics',
                    icon: 'stats',
                    id: TAB_ALBUM_ANALYTICS,
                    url: CONTENT_ALBUM_ANALYTICS
                }
            ];
        default:
            return [
                {
                    name: 'content:tabs.posts',
                    icon: 'content',
                    id: TAB_ALBUM_POSTS,
                    url: CONTENT_ALBUM_POSTS
                },
                {
                    name: 'content:tabs.analytics',
                    icon: 'stats',
                    id: TAB_ALBUM_ANALYTICS,
                    url: CONTENT_ALBUM_ANALYTICS
                }
            ];
    }
}

export const albumsTabs: TabsLinkListItemType[] = [
    {
        name: 'content:albums',
        icon: 'albums',
        id: 'my_albums',
        url: CONTENT_ALBUMS
    },
    {
        name: 'content:albums_comparative_table',
        icon: 'interface-list',
        id: 'album_comparative_table',
        url: CONTENT_ALBUMS_COMPARATIVE_TABLE
    }
];
